import { HttpHelper } from '../helpers/httpHelper';
import { UrlManager } from '../providers/urlManager/urlManager';
import { mockJR } from './samplejobreq';

export const jobApi = {
    getJobRequests: (userId, userEmail, mock = false) => {
        if (mock) {
            return new Promise(resolve => setTimeout(() => resolve(mockJR), 5000));
        }
        return HttpHelper.fetch(UrlManager.getJobRequestsUrl(), {
            queryParams: {
                userId,
                userEmail,
            },
        });
    },

    getJobDescriptions: (userId, mock = false) => {
        if (mock) {
            return new Promise(resolve => setTimeout(() => resolve(mockJR), 5000));
        }

        return HttpHelper.fetch(UrlManager.getJobRequestsUrl(), {
            queryParams: {
                userId,
            },
        });
    },

    getJobRequestDashboard: location => {
        return HttpHelper.fetch(UrlManager.getJobRequestDashboardUrl(), {
            queryParams: { location },
        });
    },

    getReviewApprovedJobRequests: () => {
        return HttpHelper.fetch(UrlManager.getReviewApprovedJobRequestsUrl());
    },

    wfmJobReviewUpdate: async data => {
        return await HttpHelper.fetch(UrlManager.getReviewWfmJobRequestUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: data,
        });
    },
    updateJobRequestStatus: async data => {
        return await HttpHelper.fetch(UrlManager.updateJobRequestStatus(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: data,
        });
    },
};
